/**
 * Calculate the prorated charge in cents for a mid-month subscription signup.
 *
 * Proration = round(monthlyPriceCents * daysRemaining / daysInMonth)
 * daysRemaining is inclusive of today (day 1 of month = full month, last day = 1/N).
 *
 * Input is always UTC dates from the server; callers should pass a UTC Date.
 */
export function calculateProratedCents(monthlyPriceCents: number, date: Date): number {
  const year = date.getUTCFullYear();
  const month = date.getUTCMonth();
  const day = date.getUTCDate();
  const daysInMonth = new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
  const daysRemaining = daysInMonth - day + 1;
  return Math.round(monthlyPriceCents * daysRemaining / daysInMonth);
}
